<template>
  <div>
    <div v-if="onWindows">
      <v-text-field
        class="input--large input--text-center"
        :autofocus="autofocus"
        v-model="newValue"
        @click="$emit('click')"
        @blur="$emit('blur')"
      />
    </div>
    <div v-else>
      <v-text-field
        class="input--large input--text-center"
        type="number"
        :autofocus="autofocus"
        v-model.number="newValue"
        @click="$emit('click')"
        @blur="$emit('blur')"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    autofocus: {
      default: true,
      type: Boolean,
    },
  },
  data () {
    return {
      newValue: null,
    }
  },
  computed: {
    onWindows () {
      // return this.$q.platform.is.electron
      return true
    },
  },
  methods: {
    toFloat (val) {
      if (!val) return null
      val = (`${val}`).replace(',', '.')
      return parseFloat(val)
    },
  },
  created () {
    this.newValue = this.onWindows ? this.value : this.toFloat(this.value)
  },
  watch: {
    value (val) {
      this.newValue = this.onWindows ? val : this.toFloat(val)
    },
    newValue (newValue) {
      console.log('aaaa')
      this.$emit('input', `${newValue}`)
    },
  },
}
</script>